import { render, staticRenderFns } from "./DP.vue?vue&type=template&id=134dc3f0&scoped=true"
import script from "./DP.vue?vue&type=script&lang=js"
export * from "./DP.vue?vue&type=script&lang=js"
import style0 from "./DP.vue?vue&type=style&index=0&id=134dc3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134dc3f0",
  null
  
)

export default component.exports